// @mui
import GlobalStyles  from '@mui/material/GlobalStyles';

// ----------------------------------------------------------------------

export default function GlobalStylesOne() {
  const inputGlobalStyles = (
    <GlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        h1: {
          margin: 0,
        },
        h2: {
          margin: 0,
        },
        p: {
          margin: 0,
        },
        // h3: {
        //   margin: 0,
        // },
        h4: {
          margin: 0,
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
          maxHeight: '100%',
          // width: 'auto',
          // height: 'auto'
        },
        ul: {
          margin: 0,
          padding: 0,
        },
      }}
    />
  );

  return inputGlobalStyles;
}
